import catalogModule from '../catalogModule';

function itemsContainer(catalogConstants) {
    "ngInject";
    return {
        restrict: 'A',
        replace: false,
        templateUrl: catalogConstants.templateUrls.itemsContainer
    }
}

catalogModule.directive("itemsContainer", itemsContainer);

export default itemsContainer;